import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { formatAsCLP } from "src/utils/formatNumber";

export const limitarPorcentajeGrafico = (porcentaje) =>
  Math.min(Math.max(Number(porcentaje) || 0, 0), 100);

export const formatearPorcentaje = (porcentaje) =>
  porcentaje === null || porcentaje === undefined
    ? "Sin base"
    : `${porcentaje.toLocaleString("es-CL", {
        minimumFractionDigits: 1,
        maximumFractionDigits: 1,
      })}%`;

MontoResumen.propTypes = {
  label: PropTypes.string.isRequired,
  secondary: PropTypes.string,
  value: PropTypes.number,
};

export function MontoResumen({ label, value = 0, secondary }) {
  return (
    <Box>
      <Typography variant="h5">{formatAsCLP(value)}</Typography>
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {label}
      </Typography>
      {secondary && (
        <Typography variant="caption" sx={{ color: "text.disabled" }}>
          {secondary}
        </Typography>
      )}
    </Box>
  );
}
